import { CurrentReservationService } from '@/common/services/reservation/current';
import {
    Billing,
    ReservationDetails,
} from '@/core/domain/billing/models/billing-body.model';
import { BillingResponse } from '@/core/domain/billing/models/billing-response.model';
import { PrecheckinStep1Repository } from '@/core/domain/precheckin/repository/precheckin-step1.repository';
import { ReservationPreChekin } from '@/core/domain/reservation/models/reservation-response';
import {
    clearPrecheckin,
    savePrecheckin,
    updatePrecheckin,
} from '@/core/reservation/store/precheckin.actions';
import { selectPrecheckin } from '@/core/reservation/store/precheckin.selector';
import { selectUser } from '@/core/user/store/reservation.selector';
import { environment } from '@/env/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import _ from 'lodash';
import { first, Observable, of, switchMap, take } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PrecheckinImplRepository extends PrecheckinStep1Repository {
    reservationPrecheck: any;
    constructor(
        private readonly store: Store,
        private readonly reservation: CurrentReservationService,
        private readonly http: HttpClient,
    ) {
        super();
    }

    override getPrecheckin(): Observable<any> {
        return this.store.select(selectPrecheckin);
    }

    override clearPrecheckin(): Observable<boolean> {
        this.store.dispatch(clearPrecheckin());
        return of(true);
    }
    override savePrecheckin(
        reservation: ReservationPreChekin,
    ): Observable<boolean> {
        this.store.dispatch(savePrecheckin({ value: reservation }));
        return of(true);
    }

    override updatePrecheckin(data: any): Observable<boolean> {
        this.store.dispatch(updatePrecheckin({ value: data }));
        return of(true);
    }

    private buildPayload(storageData: any): Billing {
        const reservationDetails: ReservationDetails = {
            pickupDate: storageData.pickupDate,
        };
        return {
            reservationCode: storageData.code,
            reservationDetails,
        };
    }

    override sendChangeHour(date: string): Observable<BillingResponse> {
        const url = [
            environment.alamoApi.BASE_HOST,
            environment.alamoApi.ENDPOINTS.preCheckInSendData,
        ].join('/');

        return this.store.select(selectPrecheckin).pipe(
            switchMap((storageData) => {
                const payload: Billing = this.buildPayload(storageData);
                return this.store.select(selectUser).pipe(
                    take(1),
                    switchMap((response) => {
                        const headers = new HttpHeaders().set(
                            'token',
                            `${response.token}`,
                        );

                        return this.http.put<BillingResponse>(url, payload, {
                            headers,
                        });
                    }),
                );
            }),
        );
    }
}
